import { useContext, useEffect, useRef, useState } from 'react';

import styles from './CurrencyComponent.module.css';

import { GlobalContext } from '../../../contexts/globalContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons'

import New_InputTextComponent from '../../keyboard/New_InputTextComponent';
import New_DropDownComponent from '../../keyboard/New_DropDownComponent';

const CurrencyComponent = ({ setSeeCurrencyFeature }) => {

    const { keyboardRef } = useContext(GlobalContext)

    const inputRef = useRef()
    const optionsToRef = useRef()
    const optionsFromRef = useRef()

    const [info, setInfo] = useState([]);
    const [input, setInput] = useState(1);
    const [from, setFrom] = useState("eur");
    const [to, setTo] = useState("usd");
    const [options, setOptions] = useState([]);
    const [output, setOutput] = useState(0);

    useEffect(() => {
        fetch(`https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/${from}.json`)
            .then((res) => {
                return res.json()
            })
            .then((data) => {
                setInfo(data[from.toLowerCase()])
            })
            .catch((err) => console.error("Error fetching currency data:", err));
    }, [from]);


    // Calling the convert function whenever
    // a user switches the currency
    useEffect(() => {
        setOptions(
            Object.keys(info).map(key => ({ value: key, name: key.toUpperCase() }))
        );

        convert();
    }, [info])

    useEffect(() => {
        convert()
    }, [input, to, from])


    // Function to convert the currency
    function convert() {
        var rate = info[to.toLowerCase()];
        setOutput(input * rate);
    }

    // Function to switch between two currency
    function flip() {
        var temp = from;
        setFrom(to);
        setTo(temp);

        optionsFromRef.current.currentChoice = { value: to, name: to.toUpperCase() }
        optionsFromRef.current.value = to;

        optionsToRef.current.currentChoice = { value: temp, name: temp.toUpperCase() }
        optionsToRef.current.value = temp;
    }


    return (
        <div className={styles.component}>
            <div className={styles.title}>
                <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fal["coins"]} />
                <div>Currency Converter</div>
                <FontAwesomeIcon className={styles.icon} onClick={() => setSeeCurrencyFeature(false)} icon={byPrefixAndName.fal["close"]} />

            </div>

            <div className={styles.options}>
                Amount
                <New_InputTextComponent ref={inputRef} keyboardRef={keyboardRef} value="1" placeholder="Enter the amount" fontSize="40px"
                    styleType='CURRENCY' width="100%" height="80px" onChange={(e) => {
                        const lastChar = e.slice(-1);
                        const isInvalid = lastChar && !/[0-9,]/.test(lastChar);

                        if (isInvalid) {
                            inputRef.current.value = e.slice(0, -1);
                            return; 
                        }

                        setInput(e)
                    }} typeOfInput="number" />

                <div className={styles.choices}>
                    <div className={styles.choice}>
                        From
                        <New_DropDownComponent options={options} ref={optionsFromRef} keyboardRef={keyboardRef} currentChoice={{ value: from, name: from.toUpperCase() }} placeHolder="From"
                            iconPosition="right" withDelete={true} styleType='CURRENCY_DD' width="400px" height="80px" fontSize="40px" position="absolute"
                            onChange={(e) => setFrom(e.toLowerCase())} value={from} elementsToShowNumber={6} typeOfInput="currencyName"/>
                    </div>

                    <div className={styles.switch} onClick={flip} >
                        <FontAwesomeIcon icon={byPrefixAndName.fal["coins"]} />

                    </div>

                    <div className={styles.choice}>
                        To
                        <New_DropDownComponent options={options} ref={optionsToRef} keyboardRef={keyboardRef} currentChoice={{ value: to, name: to.toUpperCase() }} placeHolder="To"
                            iconPosition="right" withDelete={true} styleType='CURRENCY_DD' width="400px" height="80px" fontSize="40px" position="absolute"
                            onChange={(e) => setTo(e.toLowerCase())} value={to} typeOfInput="currencyName"/>
                    </div>
                </div>

            </div>
            <div className={styles.results}>
                {input + " " + from.toUpperCase() + " = " + output.toFixed(2) + " " + to.toUpperCase()}
            </div>



        </div>
    );
}

export default CurrencyComponent;
